import overlay from './loader';
import updateMiniCart from "./update-mini-cart";
import updateCartIconQuantity from "./update-cart-icon";
import updateDatalayer from "./gtm";
import debounce from '../utils/debouncer';
import eventBus from './event-bus';
import Modal from './modal/modal';
import $ from "jquery";

let input = null;
const giftCardInput = document.getElementById('giftcard');

function checkFavorite() {
    return $('#favorite-items').length
}

function cartItem(el) {
    return $(el).parents('.is-cart-item[data-row-id]').first();
}

function cart(el) {
    return $(el).closest('[data-cart-id]');
}

function cartUrl(el) {
    return window.config.urls.cartProduct.replace(':cart:', cart(el).data('cart-id'));
}

function favoriteUrl(el) {
    return window.config.urls.favorites.deleteProduct.replace(':cart:', cart(el).data('cart-id'));
}

/**
 * @deprecated!
 * @param el
 * @returns {*}
 */
function updateFavoriteItemUrl(el) {
    return window.config.urls.favorite.update.replace(':cart:', cart(el).data('cart-id'));
}

function voucherAddUrl(el) {
    return window.config.urls.voucher.add.replace(':cart:', cart(el).data('cart-id'));
}

function voucherRemoveUrl(el) {
    return window.config.urls.voucher.remove.replace(':cart:', cart(el).data('cart-id'));
}

function hasUnselectedBookingAccounts() {
    const bookingAccounts = $('.form-select[id*="[booking_account]"]');

    return bookingAccounts.toArray().every(function (el) {
        return $(el).val() !== '';
    });
}

function disableGotoCheckoutButton() {
    $('.goto-checkout-button').prop('disabled', true);
}

function enableGotoCheckoutButton() {
    $('.goto-checkout-button').prop('disabled', false);
}

function updateItem(cartItem, cart, favorite, el) {

    const hasUnselectedBookingsAccount = hasUnselectedBookingAccounts();

    if (!hasUnselectedBookingsAccount) {
        disableGotoCheckoutButton();
    } else {
        enableGotoCheckoutButton();
    }


    overlay(true);
    let api = cartUrl(cartItem).replace(':row:', cartItem.data('row-id'));

    if (favorite) {
        api = updateFavoriteItemUrl(cartItem).replace(':rowId:', cartItem.data('row-id'));
    }

    let data = $(cartItem).find("form").first().serialize();

    window.axios.patch(api, data)
        .then(({data: {template: template, success, cartId}}) => {
            // replace cart with api response
            $(cart).first()[0].outerHTML = $(template)[0].outerHTML;

            // reselect cart
            cart = $('.is-cart[data-cart-id="' + cartId + '"]');

            // bind all events
            init(cart);

            if (success) {
                resetBreadcrumb();
                refocusInput(cart);
            }

            /**
             * Show & Hide success toast
             */
            const cartItemToast = $('#cart-item-toast-' + cartItem.data('row-id'));
            cartItemToast.show();
            setTimeout(function () {
                cartItemToast.hide();
            }, 2500);
        })
        .catch((e) => {
            const input = $(cart).find(`input[name="${cartItem.data('row-id')}[quantity]"]`);
            input.val(input.data('original'));

            const cartItemErrorToast = $('#cart-item-error-toast');
            cartItemErrorToast.show();
            setTimeout(function () {
                cartItemErrorToast.hide();
            }, 2500);
        })
        .finally(() => {
            overlay(false);

            /**
             * Emit quantity change
             */
            eventBus.emit('cart-item-quantity-change');
        });
}

function refocusInput(cart) {
    if (input !== null) {
        const elId = input.attr('id');
        const elInput = $(cart).find($(`[id*="${elId}"]`))
        elInput.focus();
        const val = elInput.val(); //store the value of the element
        elInput.val(''); //clear the value of the element
        elInput.val(val); //set that value back.
    }
}

function syncValue(el, selector, value) {
    let isInput = el.is('input, select, textarea');
    let val = typeof value === 'undefined' ? (isInput ? el.val() : el.text()) : value;
    if (isInput) {
        cartItem(el).find(selector).val(val);
    } else {
        cartItem(el).find(selector).text(val);
    }
}

function setValue(el, value, cart, favorite) {
    const item = cartItem(el.target);

    item.find('input.quantity').val(value);
    // Check if the value is 0 then remove the item from the cart.
    if (value === 0) {
        let deleteButton = $('.delete-cart-item[data-row-id="' + item.data('rowId') + '"]').first().click();
        return;
    }

    debounce(item, () => {
        updateItem(item, cart, favorite, el)
    }, 700);
}

function resetBreadcrumb() {
    $('ol.is-path--list.swiper-wrapper > li > a').addClass('disabled').attr('disabled', 'disabled').removeAttr('href');
}

function cartUrlForExport(cart) {
    return window.config.urls.exportCart.replace(':cart:', cart);
}

function downloadFile(filePath) {
    const link = document.createElement('a');
    link.href = filePath;
    link.download = filePath.substr(filePath.lastIndexOf('/') + 1);
    link.click();
}

function init(cartElement) {

    const hasUnselectedBookingsAccount = hasUnselectedBookingAccounts();

    if(!hasUnselectedBookingsAccount) {
       disableGotoCheckoutButton();
    }

    // register all needed hooks
    $(cartElement).on('change', '.cart-item-quantity-change', function (e) {
        let val = parseFloat($(this).val());
        let myCart = cart(e.target);

        setValue(e, val, myCart, checkFavorite());
    }).on('keyup', '.cart-item-quantity-change', function (e) {
        let val = parseFloat($(this).val());

        let max = $(this).data('max');
        let min = $(this).data('min');

        if (val > max) {
            $(this).val(max);
        }

        if (val < min || isNaN(val)) {
            $(this).val(min);
        }
    }).on('change', '.approval-gate-field select', function () {
        const me = $(this);
        debounce(me, function () {
            me.blur();
            updateItem(cartItem(me), cart(me), false, me);
        });
    }).on('keyup', '.approval-gate-field input, .approval-gate-field textarea', function () {
        const me = $(this);
        if (e.keyCode === 32) {
            return;
        }
        debounce(me, function () {
            me.blur();
            updateItem(cartItem(me), cart(me));
            input = me;
        }, 1200);
    }).on('keyup', 'div.comment input, div.comment textarea, div.comment textarea', function (e) {
        const me = $(this);
        if (e.keyCode === 32) {
            return;
        }
        debounce(me, function () {
            me.blur();
            updateItem(cartItem(me), cart(me));
            input = me;
        }, 1200);

        syncValue(me, '.comment-' + me.data('comment'));
    }).on('click', '.cart-action-btn', function (e) {
        e.stopPropagation();
        let selected = $('select.cart-action-select').children('option:selected').val();
        selected = $.trim(selected);
        let myCart = cart(e.target);
        let cartId = myCart.data('cart-id');
        let modal = $('#' + selected);
        if (modal) {
            switch (selected) {
                case 'exportModal':
                    modal.find('button.export-cart-btn').attr('data-cart-id', cartId);
                default:
                    modal.modal('show');
            }
        }
    }).on('keyup', '.is-counter input[type="number"]', function (e) {
        if ($(this).val() > 0) {
            setValue(e, $(this).val(), cart(e.target), false);
        }
    }).on('submit', '.is-cart-item form', function (e) {
        e.stopPropagation();
        e.preventDefault();

        const input = $(this).find('.is-counter input[type="number"]');
        const val = parseFloat(input.val());
        const myCart = cart(e.target);

        setValue({target: input}, val, myCart, false);
    });
}

function checkReferenceInput() {
    const customerReferenceInput = $('#customer_reference').val();

    if (customerReferenceInput !== undefined) {
        $("#referenceSendButton").attr('disabled', !(customerReferenceInput.length > 0));
    }
}

$(document).ready(function () {
    /**
     * Delete on item from cart (can be within mini-cart, cart page or somewhere else)
     */
    $('body').on('click', '.delete-cart-item', function (e) {
        overlay(true);
        e.stopPropagation();
        e.preventDefault();

        if ($(this).data('disabled') === true) {
            return;
        }

        $(this).data('disabled', true); // prevent redundant firing of request
        let url = window.config.urls.cartProduct;
        const rowId = $(this).data('rowId');
        const cartId = $(this).data('cartId');
        const product_name = $(this).data('productName');
        const product_number = $(this).data('productNumber');
        const price = $(this).data('price');
        url = url.replace(':cart:', cartId).replace(':row:', rowId);
        const action = $(this).data('action');
        updateDatalayer('remove_from_cart', product_number, product_name, 1, price, null);
        window.axios.delete(url).then(
            function () {
                if (
                    action === 'update-mini-cart'
                    && !window.location.href.startsWith(window.config.urls.cart) // if currently on cart overview, refresh page to sync instead TODO improve cart/minicart syncing
                ) {
                    updateMiniCart().then(updateCartIconQuantity);
                    updateDatalayer('remove_from_cart', product_number, product_name, 1, price, null);
                    overlay(false);
                } else {
                    window.location.reload();
                }
            },
            () => {
                overlay(false);
                $(this).removeData('disabled'); // on server error re-enable button
            }
        );
    });

    /**
     * Replace this followUp item from cart (can be within mini-cart, cart page or somewhere else)
     */
    $('body').on('click', '.follow-up-cart', function (e) {
        e.stopPropagation();
        e.preventDefault();
        if ($(this).data('disabled') === true) {
            return;
        }

        $(this).data('disabled', true); // prevent redundant firing of request
        let url = window.config.urls.followUp;
        const rowId = $(this).data('rowId');
        const cartId = $(this).data('cartId');
        url = url.replace(':cart:', cartId).replace(':row:', rowId);
        window.axios.post(url).then(
            function () {
                window.location.reload();
            }
        );
    });

    $('body').on('change', '.formFile', function (e) {
        const validExtensions = ['.csv', '.xlsx'];
        const uploadedFile = e.target.files[0].name;
        const extensionValidity = validExtensions.find(val => uploadedFile.includes(val));

        if (extensionValidity === undefined) {
            $(this).siblings('.formFileMessage').removeClass('d-none');
        } else {
            $(this).siblings('.formFileMessage').addClass('d-none');
        }
    });

    /**
     * Import a favorite list to cart
     */
    $('body').on('submit', '#import-favorite', function (e) {
        e.preventDefault();
        var url = $(this).attr('action');
        window.axios.post(url, $(this).serialize()).then(({data}) => {
            window.location.reload();
        });
    });

    $('body').on('change', '#select-favorite', function () {
        let value = parseInt($(this).val());
        $('#load-favorite-list').prop('disabled', value <= 0);
    });

    /**
     * Export cart to a favorite list
     */
    $('body').on('submit', '#export-favorite', function (e) {
        e.preventDefault();
        const url = $(this).attr('action');
        window.axios.post(url, $(this).serialize()).then(({data}) => {
            let modal = $(this).closest('.modal');
            if (modal) {
                modal.modal('hide');
                $('#save-to-favorite-success .go-to-specific-shopping-list').attr('href', data.url).removeClass('d-none');
                $('#save-to-favorite-success').modal('show');
            }
        });
    });

    $('body').on('click', '#openImportModal', function (e) {
        $('#importModal').modal('show');
    });

    /**
     * Activate Export Modal Primary Button if value is selected
     */
    const exportModal = document.getElementById('exportModal');
    if (typeof (exportModal) !== 'undefined' && exportModal !== null) {
        exportModal.addEventListener('shown.bs.modal', function (e) {
            const selectFormatSelect = e.target.querySelector('#selectFormat');
            selectFormatSelect.addEventListener('change', () => {
                let value = selectFormatSelect.value;
                const button = exportModal.querySelector('.export-cart-btn');
                if (value !== '-') {
                    button.removeAttribute('disabled');
                } else {
                    button.setAttribute('disabled', 'disabled');
                }
            });
        });
    }


    /**
     * Clear cart
     */
    $('body').on('submit', '#clear-cart', function (e) {
        e.preventDefault();

        $(this).closest('.modal').modal('hide');
        overlay(true);

        const url = $(this).attr('action');
        window.axios.delete(url, $(this).serialize()).then(() => {
            window.location.reload();
        }).catch(() => {
            overlay(false);
        });
    });

    function addGiftCard(e) {

        const voucherCode = $('#giftcard').val();

        if (voucherCode && voucherCode !== '') {
            const url = voucherAddUrl(e.target);

            overlay(true);

            window.axios.post(url, {
                voucher: voucherCode
            }).then(response => {
                if (response.data.cartId && response.data.template) {
                    const cartSelector = '.is-cart[data-cart-id="' + response.data.cartId + '"]';
                    $(cartSelector).replaceWith(response.data.template);
                    init($(cartSelector));
                } else {
                    window.location.reload();
                }
            }).finally(() => {
               overlay(false);
            })
        }
    }

    // Send giftcard on clicking button

    $('body').on('click', '#giftcard-btn', function (e) {
        addGiftCard(e);
        e.stopPropagation();
        e.preventDefault();
    });

    // Send giftcard on pressing enter key
    giftCardInput?.addEventListener('keypress', function(e) {
        if (event.code === 'Enter') {
            addGiftCard(e);
            e.preventDefault();
        }
    });

    $('body').on('click', '.remove-voucher-btn', function (e) {
        const voucherCode = $(e.target).data('voucher');

        if (voucherCode) {
            const url = voucherRemoveUrl(e.target);

            overlay(true);

            window.axios.post(url, {
                voucher: voucherCode
            }).then(response => {
                if (response.data.cartId && response.data.template) {
                    const cartSelector = '.is-cart[data-cart-id="' + response.data.cartId + '"]';
                    $(cartSelector).replaceWith(response.data.template);
                    init($(cartSelector));
                } else {
                    window.location.reload();
                }
            }).catch(e => {
                 Modal.alert(e.response.data.message).show();
            }).finally(() => {
                overlay(false);
            })
        }
    })

    $('body').on('click', '.export-cart-btn', function (e) {
        e.stopPropagation();
        let cartId = $(this).data('cart-id');
        let url = new URL(cartUrlForExport(cartId));
        let selected = $('#exportModal select').children('option:selected').val();
        url.searchParams.append('type', selected);
        downloadFile(url.toString());
        let modal = $(this).closest('.modal');
        if (modal) {
            modal.modal('hide');
        }
    }).on('submit', '.import-cart', function (e) {
        e.preventDefault();
        const url = $(this).attr('action');
        const formData = new FormData(this);

        window.axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(({data}) => {
            window.location.reload();
        });
    })

    checkReferenceInput();

    $('#customer_reference').on('keyup', function (e) {
        checkReferenceInput();
    });

    $('.is-cart[data-cart-id]').each(function() {
        init($(this));
    })

    $('body').on('click', '.transfer-cart-btn', function (e) {
        overlay(true);
        window.axios.post(window.config.urls.transferCart, {
            mode: $('input[name="transfer-mode"]:checked').val()
        }).then(response => {
            overlay(false);
            window.location.reload();
        });
    })

    $('body').on('click', '.nested-items-btn', function (e) {
        e.preventDefault();

        overlay(true);

        let modelId = $(this).data('model-id');
        let rowId = $(this).data('row-id');
        let type = $(this).data('type');
        let modal = $('#subItemsModal');

        let url = type === 'cart'
            ? window.config.urls.cartNestedItems.replace(':cart:', modelId).replace(':row:', rowId)
            : window.config.urls.orderNestedItems.replace(':order:', modelId).replace(':row:', rowId);

        window.axios.get(url).then(response => {
            modal.find('.title').text(response.data.title);
            modal.find('.modal-body').html(response.data.items);
            modal.modal('show');
        }).catch(e => {
            Modal.alert(e.response.data.message).show();
        }).finally(() => {
            overlay(false);
        });
    });
});
